export enum Environment {
  DEV = 'dev',
  STAGING = 'staging',
  UAT = 'uat',
  PROD = 'prod',
}
